export const OFFER_PARTNER_VERIFICATIONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerVerificationInvalidated";
  export const DOCUMENT_VERIFICATION_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.DocumentVerification.DocumentVerificationUpdated";
  export const DOCUMENT_VERIFICATION_STARTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.DocumentVerification.DocumentVerificationStarted";

